class Upload {

    constructor() {

        this._src = 'file/';//文件夹地址
        this._file = null;//文件
        this._name = '';//文件名
        this._suffix = '';//后缀

    }
    src(_src) {
        this._src = _src;//文件夹地址
        return this;
    }
    file(_file) {
        this._file = _file;//文件夹地址
        return this;
    }
    static getSuffix(str) {
        let names = str.split('.');
        return names[names.length - 1];
    }
    suffix(_suffix) {
        this._suffix = _suffix;
        return this;
    }
    send(callback = new Function(), error = new Function()) {

        const client = new OSS.Wrapper({
            // region: 'https://pic.ruibei365.com',//你的oss地址 ，具体位置见下图
            region: 'oss-cn-beijing',//你的oss地址 ，具体位置见下图
            accessKeyId: 'LTAIEiYzzsqf3kVG',//你的ak
            accessKeySecret: 'jtVJekZZev4SICaUjhXZ3gavhXSfo4',//你的secret
            bucket: 'ruibei365bk',//你的oss名字
            secure: true
        });

        let name = this._src + (new Date()).Format("yyyyMMddhms") + Math.floor(Math.random() * 100) + '.' + this._suffix;

        client.multipartUpload(name, this._file).then((result) => {
            var client = new OSS({ //这里是设置图片预览地址
                // region: 'https://pic.ruibei365.com',//你的oss地址 ，具体位置见下图
                region: 'oss-cn-beijing',//你的oss地址 ，具体位置见下图
                accessKeyId: 'LTAIEiYzzsqf3kVG',//你的ak
                accessKeySecret: 'jtVJekZZev4SICaUjhXZ3gavhXSfo4',//你的secret
                bucket: 'ruibei365bk'//你的oss名字
            });
            var signUrl = client.signatureUrl(name, { expires: 6000, 'process': 'image/resize,w_300' });
            callback(name, signUrl, result);
        }).catch(function (err) {
            error(error);
        });

        return this;
    }


}
export default Upload